<script>
    import { Container, ScrollAnchor } from '@/components'
</script>


<Container>
    <ScrollAnchor id="func" />
    <div class="wrapper">
        <div>
            <h2 class="title">EmployeeGate автоматизирует<br/>
            большинство рутинных задач</h2>
            
            <div class="description">
                EmployeeGate — это расширение стандартной конфигурации<br/> 
                1С:ЗУП с бесшовной двухсторонней интеграцией и регулярной<br/> 
                синхронизацией. Обеспечивает безопасный доступ к <br/> 
                персональным данным и документам на десктопе через любой<br/>
                современный браузер (Google Chrome, Edge, Opera, Yandex Browser),<br/> 
                а также адаптированный мобильный интерфейс под iOS, Android,<br/> 
                Windows Mobile.
            </div>
        </div>
    </div>

    <div slot="background" class="background">
        <div class="figures" />
    </div>
</Container>

<style lang="scss">
    .wrapper {
        .title {
            margin-top: 193px;
            line-height: 50px;
            color: #ffffff;

            @media (max-width: 1024px) {
                margin-top: 478px;
            }
        }
        
        .description {
            margin-top: 40px;
            font-size: 22px;
            line-height: 28px;
            color: #ffffff;
            margin-bottom: 255px;
        }
    }

    .background {
        position: absolute;
        top: 0;
        left: 0;
        z-index: -1;
        width: 100%;
        height: 100%;
        background-image: url('../img/automatization-background.png');
        background-repeat: no-repeat;
        background-size: cover;

        .figures {
            width: 807px;
            height: 658px;
            position: absolute;
            top: 86px;
            right: 6vw;
            z-index: 1;
            background-image: url('../img/puzzles.png');
            background-repeat: no-repeat;
            background-size: contain;
            background-position: right;

            @media (max-width: 1640px) {
                right: -6vw;
            }

            @media (max-width: 1500px) {
                right: -8vw;
            }

            @media (max-width: 1024px) {
                right: unset;
                top: 58px;
                left: calc(50% - 270px);
                width: 541px;
                height: 441px;
            }
        }
    }

    @media (max-width: 834px) {
        .wrapper {
            display: block;
            
            .title,
            .description {
                br {
                    display: none;
                }
            }
        }
    }

    @media (max-width: 420px) {
        .wrapper {
            .description {
                font-size: 14px;
                line-height: 18px;
                margin-bottom: 68px;
            }
        }
    }
</style>

